module.exports = __webpack_public_path__ + "img/th-web.1a3e073a.jpg";